export interface IHelpContent {
  articleId?: string;
  categoryId: string;
  content?: string;
  title: string;
  userTypes?: number[];
}

export interface IHelpCategory {
  title: string;
  categoryId: string;
  articles: IHelpContent[];
  userTypes?: number[];
}

export const initialHelpArticle = {
  title: "",
  categoryId: "",
  content: ""
}


// WEBPACK FOOTER //
// ./src/modules/UserSettings/Help/types/help.ts